<template>
	<div>
		<m-list
			ref="planningslist"
			:dynamic="true"
			:items="plannings"
			item-value="pl_id"
			:item-height="30"
			:limit="plannings_limit"
			:skip="plannings_skip"
			:total="plannings_total"
			:current="plannings_current"
			:bgstrip="true"
			@changerange="planningsChangerange"
		>
			<template v-slot:ths="{}">
				<th style="width: 20%">
					<span class="pointer">Publié par</span>
				</th>
				<th style="width: 20%">
					<span class="pointer">Statut envoi</span>
				</th>
				<th style="width: 35%">
					<span class="pointer">Message</span>
				</th>
				<th class="text-center" style="width: 10%">
					<span class="pointer">Image</span>
				</th>
				<th class="text-center" style="width: 60px;">
				</th>
				<th class="text-center" style="width: 60px;">
				</th>
			</template>
			<template v-slot:tds="{ item }">
				<td style="width: 20%">
					{{ item.us_id.us_firstname }} {{ item.us_id.us_name }}
				</td>
				<td style="width: 20%">
					<span v-if="$moment().isSameOrAfter(item.pl_datedebut)">
						envoyé le
					</span>
					<span v-else>
						prévu le 
					</span>
					{{ $moment(item.pl_datedebut).format("DD/MM/YYYY HH:mm") }}
				</td>
				<td style="width: 35%">
					{{ item.pl_message ? item.pl_message : "" }}
				</td>
				<td :id="'planningMessage_' + item.pl_id" class="text-center" style="width: 10%">
					{{ item.pl_messagemedia ? getThumbnail(item) : "" }}
				</td>
				<td class="text-center" style="width: 6,6%;">
					<div v-show="$moment().isBefore(item.pl_datedebut)" @click="modifyPublication(item, $event)">
						<icon width="20" height="20" name="pen" class="text-danger" />
					</div>
				</td>
				<td class="text-center" style="width: 6,6%;">
					<div @click="clonePublication(item, $event)">
						<icon width="20" height="20" name="clone" class="text-danger" />
					</div>
				</td>
				<td class="text-center" style="width: 6,6%;">
					<div @click="deletePublication(item, $event)">
						<icon width="20" height="20" name="trash-alt" class="text-danger" />
					</div>
				</td>
			</template>
		</m-list>
		<v-spinner ref="waitingSpinnerModal" />
	</div>     
</template>

<script>
export default {

	name: "ScheduledMessagesList",
	components: {},
	props: {
		allEndUsers: {
			default: 0,
			type: Number
		},
		row_en: Object
	},

	data() {
		return {
			sortOrder: "asc",
			sortFields: ["pl_id"],
			plannings_limit: 50,
			plannings_skip: 0,
			plannings_total: 0,
			plannings_current: "",
			plannings: []
		};
	},

	mounted() {
		this.loadPlannings();
	},

	destroyed() {

	},

  	created() {

	},

	methods: {
	
		getThumbnail(planning) {

			if (document.getElementById("planningMessageMedia_" + planning.pl_id)) {
				return;
			}

			var myCan = document.createElement("canvas");
			var img = new Image();

			img.src = this.$config.server_url + planning.pl_messagemedia;
			img.crossOrigin = "anonymous";

			img.onload = function() {

				myCan.id = "planningMedia_" + planning.pl_id;
				myCan.width = 30;
				myCan.height = 30;
				if (myCan.getContext) {
					var cntxt = myCan.getContext("2d");
					cntxt.drawImage(img, 0, 0, myCan.width, myCan.height);
					var dataURL = myCan.toDataURL();

					if (dataURL != null && dataURL != undefined) {
					var nImg = document.createElement("img");
					nImg.id = "planningMessageMedia_" + planning.pl_id;
					nImg.src = dataURL;
					document.getElementById("planningMessage_" + planning.pl_id).appendChild(nImg);
					}
				}
			};
		},

		waitingSpinner(display, text) {
			if (this.$refs.waitingSpinnerModal) {
				this.$refs.waitingSpinnerModal.changeDisplay(display, text);
			}
		},

		async loadPlannings() {

			console.log("load planning")

			let types = [];
			let sort = this.sortFields.reduce((accumulator, field) => {
					if (accumulator) {
						accumulator += ", ";
					}
					accumulator += field + " " + this.sortOrder;
					return accumulator;
				}, "");

			let params = {

				types: types,
				skip: this.plannings_skip,
				limit: this.plannings_limit,
				sort: sort,
				us_id: this.$store.state.user.us_id,
				//pl_sendtoall: this.allEndUsers
	
			};

			if (this.row_en && this.row_en.en_id) {
				params.en_ids = "[" + this.row_en.en_id + "]";
			}

			this.cancelAxiosLoadContacts && this.cancelAxiosLoadContacts();

			let response = await this.$axios.get(this.$config.server_url + "/extranet/2.0/plannings", {
				params,
				cancelToken: new this.$axios.CancelToken(c => {
					this.cancelAxiosLoadContacts = c;
				})});

			if (!response || !response.data) {
				return;
			}

			this.plannings = response.data.data;
			this.plannings_total = response.data.meta.total;
		},

		planningsChangerange(skip, scrollTop) {
			this.plannings_skip = skip;
			this.loadPlannings();
		},

		sortItems(fields) {

			if (fields.length && this.sortFields.length && fields[0] == this.sortFields[0]) {
				this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
			}

			this.sortFields = fields;

			this.loadPlannings(false);
		},

		modifyPublication(planning) {
			this.$router.push(`/messages/edit/${planning.pl_id}`);
		},

		clonePublication(planning) {
			this.$router.push(`/messages/clone/${planning.pl_id}`);
		},

		async deletePublication(planning) {
			let response = await this.$axios.delete(this.$config.server_url + "/extranet/2.0/plannings/" + planning.pl_id);
			if (response && response.data && response.data.error) alert("Une erreur est survenue lors de la suppression du message planifié");
			else if (response && response.data && response.data.data) this.loadPlannings();
		},
	},

	watch: {

	}
};
</script>

<style scoped lang="scss">
@import "../scss/styles.scss";

input {
  margin-top: 20px;
}

.trash {
  right: 65px;
}
</style>
